<template>
  <div>
    <div :class="NavSolid ? ' ' : 'menu-area-body'" style="height: 5rem"></div>

    <div class="bg-light py-5">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-10">
            <div class="card border-0 shadow rounded-lg" data-aos="fade-up">
              <div class="card-body p-4 p-md-5">
                <!-- Spanish Version -->
                <section lang="es" id="spanish-version" aria-labelledby="spanish-title">
                  <div class="mb-4 pb-3 border-bottom">
                    <h1 class="text-primary font-weight-bold mb-1">Política de Privacidad</h1>
                    
                  </div>

                  <div class="policy-content">
                    <h2>1. Introducción</h2>
                    <p>
                      Total Realty ("nosotros" o "nuestra empresa") valora su privacidad. Esta Política de Privacidad explica cómo recopilamos, usamos y protegemos su información cuando
                      utiliza nuestro sitio web, nuestros servicios y nuestras integraciones con plataformas de terceros como Facebook e Instagram.
                    </p>
                    <p>Al utilizar nuestros servicios, usted acepta las prácticas descritas en esta Política de Privacidad.</p>

                    <h2>2. Información que Recopilamos</h2>
                    <p>Podemos recopilar los siguientes tipos de información:</p>
                    <ul>
                      <li><strong>Información Personal:</strong> Nombre, dirección de correo electrónico, número de teléfono y otros datos de contacto al registrarse o enviar consultas.</li>
                      <li><strong>Información de Propiedades:</strong> Detalles que usted proporcione al crear, publicar o administrar anuncios inmobiliarios.</li>
                      <li><strong>Datos de Uso:</strong> Dirección IP, tipo de navegador, información del dispositivo y actividad de navegación en nuestro sitio web.</li>
                      <li>
                        <strong>Datos de Terceros:</strong> Información obtenida a través de integraciones con Facebook, Instagram y otras plataformas para publicar anuncios, administrar
                        clientes potenciales o brindar servicios publicitarios.
                      </li>
                    </ul>

                    <h2>3. Cómo Usamos Su Información</h2>
                    <p>Utilizamos la información recopilada para:</p>
                    <ul>
                      <li>Proveer y mejorar nuestros servicios de publicación y gestión de propiedades.</li>
                      <li>Publicar y sincronizar anuncios en plataformas como Facebook e Instagram.</li>
                      <li>Comunicarnos con usted respecto a consultas, clientes potenciales o soporte.</li>
                      <li>Enviar mensajes promocionales o de mercadeo (solo con su consentimiento).</li>
                      <li>Cumplir con obligaciones legales y prevenir fraude o mal uso.</li>
                    </ul>

                    <h2>4. Compartición de Información</h2>
                    <p>Podemos compartir información en las siguientes circunstancias:</p>
                    <ul>
                      <li><strong>Con Proveedores de Servicios:</strong> Para ayudarnos a operar el sitio web, procesar pagos o prestar servicios.</li>
                      <li><strong>Con Meta (Facebook/Instagram):</strong> Para habilitar la publicación de anuncios, propiedades o servicios relacionados a través de sus APIs.</li>
                      <li><strong>Por Razones Legales:</strong> Para cumplir con leyes, regulaciones o solicitudes legales aplicables.</li>
                    </ul>
                    <p>No vendemos ni alquilamos información personal a terceros.</p>

                    <h2>5. Seguridad de los Datos</h2>
                    <p>Implementamos medidas técnicas y organizativas apropiadas para proteger su información personal contra acceso, uso o divulgación no autorizados.</p>

                    <h2>6. Retención de Datos</h2>
                    <p>
                      Conservamos su información únicamente durante el tiempo necesario para los fines descritos en esta Política de Privacidad, salvo que la ley requiera un período de
                      retención mayor.
                    </p>

                    <h2>7. Sus Derechos</h2>
                    <p>Dependiendo de su ubicación, puede tener derechos bajo leyes de protección de datos, incluyendo el derecho a:</p>
                    <ul>
                      <li>Acceder a la información que tenemos sobre usted.</li>
                      <li>Solicitar corrección o eliminación de su información personal.</li>
                      <li>Optar por no recibir comunicaciones promocionales en cualquier momento.</li>
                    </ul>

                    <h2>8. Cookies y Seguimiento</h2>
                    <p>
                      Nuestro sitio web puede utilizar cookies y tecnologías similares para mejorar su experiencia de navegación y analizar el tráfico del sitio. Usted puede ajustar la
                      configuración de su navegador para deshabilitar cookies si lo prefiere.
                    </p>

                    <h2>9. Enlaces a Terceros</h2>
                    <p>Nuestro sitio web puede contener enlaces a sitios de terceros. No somos responsables de las prácticas de privacidad ni del contenido de esos sitios externos.</p>

                    <h2>10. Privacidad de los Niños</h2>
                    <p>Nuestros servicios no están dirigidos a menores de 13 años. No recopilamos deliberadamente información personal de menores.</p>

                    <h2>11. Cambios a Esta Política</h2>
                    <p>Podemos actualizar esta Política de Privacidad de vez en cuando. Cualquier cambio se publicará en esta página con una fecha de vigencia actualizada.</p>
                  </div>
                </section>

                <!-- Divider between languages -->
                <div class="divider my-5" aria-hidden="true"></div>

                <!-- English Version -->
                <section lang="en" id="english-version" aria-labelledby="english-title">
                  <div class="mb-4 pb-3 border-bottom">
                    <h1 class="text-primary font-weight-bold mb-1">Privacy Policy</h1>
                    
                  </div>

                  <div class="policy-content">
                    <h2>1. Introduction</h2>
                    <p>
                      Total Realty ("we," "our," or "us") values your privacy. This Privacy Policy explains how we collect, use, and protect your information when you use our website,
                      services, and integrations with third-party platforms such as Facebook and Instagram.
                    </p>
                    <p>By using our services, you agree to the practices described in this Privacy Policy.</p>

                    <h2>2. Information We Collect</h2>
                    <p>We may collect the following types of information:</p>
                    <ul>
                      <li><strong>Personal Information:</strong> Name, email address, phone number, and other contact details when you register or submit inquiries.</li>
                      <li><strong>Property Information:</strong> Details you provide when creating, publishing, or managing real estate listings.</li>
                      <li><strong>Usage Data:</strong> IP address, browser type, device information, and browsing activity on our website.</li>
                      <li>
                        <strong>Third-Party Data:</strong> Information obtained through integrations with Facebook, Instagram, and other platforms to publish listings, manage leads, or deliver
                        advertising services.
                      </li>
                    </ul>

                    <h2>3. How We Use Your Information</h2>
                    <p>We use the information we collect for purposes including:</p>
                    <ul>
                      <li>Providing and improving our real estate listing and management services.</li>
                      <li>Publishing and synchronizing property listings across platforms such as Facebook and Instagram.</li>
                      <li>Communicating with you regarding inquiries, leads, or customer support.</li>
                      <li>Sending marketing or promotional messages (only with your consent).</li>
                      <li>Complying with legal obligations and protecting against fraud or misuse.</li>
                    </ul>

                    <h2>4. Sharing of Information</h2>
                    <p>We may share information in the following circumstances:</p>
                    <ul>
                      <li><strong>With Service Providers:</strong> To help us operate our website, process payments, or deliver services.</li>
                      <li><strong>With Meta (Facebook/Instagram):</strong> To enable publishing of listings, ads, or related services through their APIs.</li>
                      <li><strong>For Legal Reasons:</strong> To comply with applicable laws, regulations, or legal requests.</li>
                    </ul>
                    <p>We do not sell or rent personal information to third parties.</p>

                    <h2>5. Data Security</h2>
                    <p>We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, use, or disclosure.</p>

                    <h2>6. Data Retention</h2>
                    <p>We keep your information only as long as necessary for the purposes outlined in this Privacy Policy, unless a longer retention period is required by law.</p>

                    <h2>7. Your Rights</h2>
                    <p>Depending on your location, you may have rights under data protection laws, including the right to:</p>
                    <ul>
                      <li>Access the information we hold about you.</li>
                      <li>Request correction or deletion of your personal information.</li>
                      <li>Opt-out of marketing communications at any time.</li>
                    </ul>

                    <h2>8. Cookies and Tracking</h2>
                    <p>
                      Our website may use cookies and similar technologies to enhance your browsing experience and analyze site traffic. You can adjust your browser settings to disable cookies
                      if you prefer.
                    </p>

                    <h2>9. Third-Party Links</h2>
                    <p>Our website may contain links to third-party sites. We are not responsible for the privacy practices or content of those external sites.</p>

                    <h2>10. Children's Privacy</h2>
                    <p>Our services are not directed to children under 13. We do not knowingly collect personal information from children.</p>

                    <h2>11. Changes to This Policy</h2>
                    <p>We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated effective date.</p>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["NavSolid"],
  components: {},
  name: "PrivacyPolicy",
};
</script>

<style scoped>
.policy-content h2 {
  font-size: 1.25rem;
  margin-top: 2rem;
  margin-bottom: 1rem;
  color: var(--primary);
  font-weight: 600;
}

.policy-content h2:first-of-type {
  margin-top: 0;
}

.policy-content ul {
  margin-bottom: 1.2rem;
  padding-left: 1.5rem;
}

.policy-content li {
  margin-bottom: 0.5rem;
  line-height: 1.6;
}

.policy-content p {
  line-height: 1.7;
  margin-bottom: 1rem;
  color: var(--text);
}

.divider {
  border-top: 2px dashed var(--border);
}

section h1 {
  font-size: 1.75rem;
  color: var(--primary);
}
</style>
